module.exports = __webpack_public_path__ + "img/url-editado.6890c40b.svg";